import { Button, styled, SxProps } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useFirebaseImageUpload } from "./use-firebase-image-upload";
import { FirebasePaths } from "../../utils/firebase";

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const FirebaseImageUpload = ({
  multiple = false,
  path = FirebasePaths.DEFAULT,
  sx,
}: {
  multiple?: boolean;
  path?: FirebasePaths;
  sx?: SxProps;
}) => {
  const { loading, onUpload } = useFirebaseImageUpload(path);

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      loading={loading}
      disabled={loading}
      sx={sx}
    >
      Upload files
      <VisuallyHiddenInput
        type="file"
        onChange={(e) =>
          onUpload(e.target.files ?? ([] as unknown as FileList))
        }
        multiple={multiple}
        aria-label="Upload files"
        name="upload-files"
        id="upload-files"
      />
    </Button>
  );
};
